/**
 * Native smooth-scroll to a section anchor (e.g. "#services"), robust
 * against missing elements and being called from a page that doesn't even
 * have the section.
 *
 * Order of fallbacks:
 *   1. Native element.scrollIntoView({ behavior: 'smooth' })
 *   2. window.scrollTo with computed top — last-ditch
 *
 * If the section isn't in the current DOM, this resolves false so the
 * caller can navigate-then-scroll via sessionStorage instead.
 */
export const scrollToSection = (selector: string): boolean => {
  const target = document.querySelector(selector);
  if (!target) return false;

  // 1) Native smooth scroll — the browser's own scrolling, no interpolation
  //    layer to fight.
  try {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  } catch (err) {
    console.warn('[scrollToSection] scrollIntoView threw, falling back:', err);
  }

  // 2) Manual — should never get here, but if the above fails we still
  //    move the viewport to roughly the right place.
  const rect = target.getBoundingClientRect();
  const top = rect.top + (window.scrollY || window.pageYOffset || 0);
  window.scrollTo({ top, behavior: 'smooth' });
  return true;
};
